export default "__VITE_ASSET__MKADFwgg__"